<template>
  <Box>
    <template #content>
      <div class="table_main">
        <div class="query">
          <div class="left">
            <el-form ref="query_form" :model="queryParams" label-width="80px">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="所在企业" prop="companyname">
                    <el-input size="small" v-model="queryParams.companyname"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="企业编码" prop="companycode">
                    <el-input size="small" v-model="queryParams.companycode"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="省市区" prop="qy">
                    <Region :qy="queryParams.qy" @change="change" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="right">
            <Btn @click="query" round>
              <span class="btn_box">
                <i class="iconfont icon-sousuo"></i>
                <span>搜索</span>
              </span>
            </Btn>
            <Btn @click="initQuery" round>
              <span class="btn_box">
                <i class="iconfont icon-chongzhi"></i>
                <span>重置</span>
              </span>
            </Btn>
          </div>
        </div>
        <div class="content">
          <Table :datas="tableData" :heads="tableHead" :selection="false" :loading="loading">
            <template #handle="data">
              <div class="table_cell">
                <span v-if="data.head.handle == 'index'">{{
                (pageData.page - 1) * pageData.pageSize + data.index
                }}</span>
                <span v-if="data.head.handle == 'status'" :class="['pre']">
                  <span class="_pre" :style="{
                    background: (
                      sbstate.find((a) => a.value == data.data.sbstate) || {}
                    ).color,
                  }"></span>
                  <span>{{ data.data.sbstate }}</span>
                </span>
                <div v-if="data.head.handle == 'btns'">
                  <Btn type="text" v-if="hasPermi('system:cs:querySbCs')" @click="handleItem(data.data, '设置详情')">
                    设置详情</Btn>
                  <Btn type="text" v-if="hasPermi('system:lscs:sbLscsList')"
                    @click="toPath(`/HistoryParameter`, data.data)">历史参数</Btn>
                  <Btn type="text" v-if="hasPermi('system:cs:parameterSynchronization')"
                    @click="handleItem(data.data, '设置与同步')">设置与同步</Btn>
                  <Btn type="text" v-if="hasPermi('system:cs:printerReset')"
                    @click="initDMJ(data.data)">打码机重置</Btn>
                  <Btn type="text" v-if="hasPermi('system:cs:commandIssued') && false"
                    @click="commandIssued(data.data)">指令下发</Btn>
                </div>
              </div>
            </template>
          </Table>
          <el-pagination class="page" background layout="total, sizes, prev, pager, next" :total="pageData.total" :page-sizes = "[10, 20, 50, 100]"
            :current-page.sync="pageData.page" :page-size.sync="pageData.pageSize" @size-change="query" @current-change="getList">
          </el-pagination>
        </div>
      </div>
      <Drawer :open="open" @changeOpen="changeOpen" :title="drawerTitle" :width="830">
        <template #content>
          <el-form :model="addForm" ref="addForm" prop="addForm" :rules="rules" label-width="180px" :class="[
            'demo-ruleForm',
            'formBox',
            paramEditable() ? 'disabled' : '',
          ]" :disabled="paramEditable()">
            <div class="inTitle">外设参数1</div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="电子称IP地址：" prop="LectronicWeigherIP" v-if="paramEditable('system:cs:paramSet:TbxLectronicWeigherIP')">
                  <el-input size="small" v-model="addForm.LectronicWeigherIP"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电子秤端口号：" prop="LectronicWeigherIPPort" v-if="paramEditable('system:cs:paramSet:NtbxLectronicWeigherPort')">
                  <el-input-number size="small" v-model.number="addForm.LectronicWeigherIPPort"
                    controls-position="right" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="电子秤型号：" prop="LectronicWeigherModel" v-if="paramEditable('system:cs:paramSet:CombNtbxLectronicWeigherModel')">
                  <el-select size="small" v-model="addForm.LectronicWeigherModel">
                    <el-option v-for="item in euipData" :key="`${item.id}`" :label="item.xhname" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="自动采集模块IP地址：" prop="PhotoelectricDeviceIP" v-if="paramEditable('system:cs:paramSet:TbxAutoCollectionIP')">
                      <el-input size="small" v-model="addForm.PhotoelectricDeviceIP"></el-input>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="自动采集模块端口：" prop="PhotoelectricDeviceIPPort" v-if="paramEditable('system:cs:paramSet:NtbxAutoCollectionPort')">
                      <el-input-number size="small" v-model.number="addForm.PhotoelectricDeviceIPPort" controls-position="right" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="刷唛设备IP地址：" prop="BranderIP" v-if="paramEditable('system:cs:paramSet:TbxBranderIP')">
                      <el-input size="small" v-model="addForm.BranderIP"></el-input>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="刷唛设备端口：" prop="BranderPort" v-if="paramEditable('system:cs:paramSet:NtbxBranderPort')">
                      <el-input-number size="small" v-model.number="addForm.BranderPort" controls-position="right" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="刷唛类型：" prop="BrandModel" v-if="paramEditable('system:cs:paramSet:CombBranderType')">
                      <el-select size="small" v-model="addForm.BrandModel">
                          <el-option v-for="item in BrandModels" :key="`${item.value}`" :label="item.label"
                                     :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="定位模块串口号：" prop="GPSModuleCOM" v-if="paramEditable('system:cs:paramSet:CombPositionAndTiming')">
                      <el-select size="small" v-model="addForm.GPSModuleCOM">
                          <el-option v-for="item in com1_9" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
<!--                <el-form-item label="刷唛机模块串口号：" prop="BranderCOM" v-if="paramEditable('system:cs:paramSet:CombBranderCOM')">-->
<!--                  <el-select size="small" v-model="addForm.BranderCOM">-->
<!--                    <el-option v-for="item in com1_9" :key="item.value" :label="item.label" :value="item.value">-->
<!--                    </el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->
                  <el-form-item label="压花机模块串口号：" prop="EmbosserCOM" v-if="paramEditable('system:cs:paramSet:CombIntelligenceManagement')">
                      <el-select size="small" v-model="addForm.EmbosserCOM">
                          <el-option v-for="item in com1_9" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="电源控制器串口号：" prop="PowerControlCOM" v-if="paramEditable('system:cs:paramSet:CombPowerControl')">
                      <el-select size="small" v-model="addForm.PowerControlCOM">
                          <el-option v-for="item in com1_9" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="定位模块波特率：" prop="GPSBaudRate" v-if="paramEditable('system:cs:paramSet:GPSBaudRate')">
                      <el-select size="small" v-model="addForm.GPSBaudRate">
                          <el-option v-for="item in baudRate" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="压花机模块波特率：" prop="EmbosserBaudRate" v-if="paramEditable('system:cs:paramSet:EmbosserBaudRate')">
                      <el-select size="small" v-model="addForm.EmbosserBaudRate">
                          <el-option v-for="item in baudRate" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="电源控制器波特率：" prop="PowerControlBaudRate" v-if="paramEditable('system:cs:paramSet:PowerControlBaudRate')">
                      <el-select size="small" v-model="addForm.PowerControlBaudRate">
                          <el-option v-for="item in baudRate" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
            </el-row>
            <div class="inTitle">外设参数2</div>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="回潮仪IP地址：" prop="MoistureMeterIP" v-if="paramEditable('system:cs:paramSet:TbxMoistureMeterIP')">
                      <el-input size="small" v-model="addForm.MoistureMeterIP"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="回潮仪端口：" prop="MoistureMeterIPPort" v-if="paramEditable('system:cs:paramSet:NtbxMoistureMeterPort')">
                      <el-input-number size="small" v-model.number="addForm.MoistureMeterIPPort" controls-position="right" />
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="外挂屏IP地址：" prop="ScreenIP" v-if="paramEditable('system:cs:paramSet:TbxScreenIP')">
                      <el-input size="small" v-model="addForm.ScreenIP"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="外挂屏端口：" prop="ScreenPort" v-if="paramEditable('system:cs:paramSet:NtbxScreenPort')">
                      <el-input-number size="small" v-model.number="addForm.ScreenPort" controls-position="right" />
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="外挂屏型号：" prop="ScreenModel" v-if="paramEditable('system:cs:paramSet:CombScreenModel')">
                      <el-select size="small" v-model="addForm.ScreenModel">
                          <el-option v-for="item in ScreenModels" :key="`ScreenModels${item.value}`" :label="item.label"
                                     :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="12">

              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="外接屏内容类型：" prop="ScreenContentType" v-if="paramEditable() || (hasPermi('system:cs:paramSet:CombScreenContentType') && hasPermi('system:cs:paramSet:CbxContentProductionParameters','system:cs:paramSet:CbxContentCustomization'))">
                  <el-radio-group size="small" v-model="addForm.ScreenContentType">
                    <el-radio label="生产参数" v-if="paramEditable('system:cs:paramSet:CbxContentProductionParameters')">生产参数</el-radio>
                    <el-radio label="自定义内容" v-if="paramEditable('system:cs:paramSet:CbxContentCustomization')">自定义内容</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="外接屏幕滚动设置：" prop="ScreenScrollWay" v-if="paramEditable('system:cs:paramSet:CombScrollWay')">
                  <el-select size="small" v-model="addForm.ScreenScrollWay">
                    <el-option v-for="item in ScreenScrollWays" :key="`ScreenScrollWay${item.value}`"
                      :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item v-show="addForm.ScreenContentType == '自定义内容'" label="自定义内容：" prop="ScreenCustomContent"
                              v-if="addForm.ScreenContentType == '自定义内容' && (paramEditable('system:cs:paramSet:CbxContentCustomization'))">
                  <el-input type="textarea" size="small" v-model="addForm.ScreenCustomContent"></el-input>
                </el-form-item>
                <el-form-item label="生产参数：" v-if="addForm.ScreenContentType != '自定义内容' && (paramEditable('system:cs:paramSet:CbxContentProductionParameters'))">
                  <div class="pl10">
                    <el-checkbox v-model="addForm.ScreenContentBaleNo" prop="ScreenContentBaleNo" v-if="paramEditable('system:cs:paramSet:CbxContentBaleNumber')">包号</el-checkbox>
                    <el-checkbox v-model="addForm.ScreenContentSeedCottonLevel" prop="ScreenContentSeedCottonLevel" v-if="paramEditable('system:cs:paramSet:CbxContentSeedCottonLevel')">籽棉等级</el-checkbox>
                    <el-checkbox v-model="addForm.ScreenContentNet" prop="ScreenContentNet" v-if="paramEditable('system:cs:paramSet:CbxContentNet')">净重</el-checkbox>
                    <el-checkbox v-model="addForm.ScreenContentTare" prop="ScreenContentTare" v-if="paramEditable('system:cs:paramSet:CbxContentTare')">皮重</el-checkbox>
                    <el-checkbox v-model="addForm.ScreenContentReturnHumidityCate" prop="ScreenContentReturnHumidityCate" v-if="paramEditable('system:cs:paramSet:CbxContentReturnHumidityCate')">回潮率</el-checkbox>
                    <el-checkbox v-model="addForm.ScreenContentProcessingType" prop="ScreenContentProcessingType" v-if="paramEditable('system:cs:paramSet:CbxContentProcessingType')">加工类型</el-checkbox>
                    <el-checkbox v-model="addForm.ScreenContentProcessingBatchNumber" prop="ScreenContentProcessingBatchNumber" v-if="paramEditable('system:cs:paramSet:CbxContentProcessingBatchNumber')">当前加工批号</el-checkbox>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="inTitle">生产参数</div>
            <el-row :gutter="20">
              <!-- <span class="fwz" v-if="!paramEditable()">——</span> -->
              <el-col :span="12">
                  <el-form-item label="棉花品种：" prop="CottonKind" v-if="paramEditable('system:cs:paramSet:TbxCottonKind')">
                      <el-input size="small" v-model="addForm.CottonKind"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="异性纤维：" prop="ForeignFiber" v-if="paramEditable('system:cs:paramSet:CombForeignFiber')">
                      <el-select size="small" v-model="addForm.ForeignFiber">
                          <el-option v-for="item in ForeignFibers" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="加工类型权限：" prop="ProcessingTypeAuth" v-if="paramEditable('system:cs:paramSet:CombProcessingTypeAuth')">
                      <el-select size="small" v-model="addForm.ProcessingTypeAuth" @change="ProcessingTypeAuthChange">
                          <el-option v-for="item in ProcessingTypeAuths" :label="item.label" :key="item.value" :value="item.value"></el-option>
                      </el-select>
                  </el-form-item>
                  <!-- <span class="fwz" v-if="!paramEditable()">——</span> -->
              </el-col>
              <el-col :span="12">
                  <el-form-item label="加工类型：" prop="ProcessingType" v-if="paramEditable('system:cs:paramSet:CombProcessingType')">
                      <el-select size="small" v-model="addForm.ProcessingType">
                          <el-option v-for="item in (
                      ProcessingTypeAuths.find(
                        (a) => a.value == addForm.ProcessingTypeAuth
                      ) || { children: [] }
                    ).children" :key="`ProcessingType${item}`" :label="jglx.find((a) => a.value == item).label"
                                     :value="item">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="加工批号：" prop="BatchNo" v-if="paramEditable('system:cs:paramSet:TbxBatchNo')">
                      <el-input-number size="small" v-model.number="addForm.BatchNo" controls-position="right" :min="1" :max="999" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="包号：" prop="BaleNo" v-if="paramEditable('system:cs:paramSet:TbxBaleNo')">
                      <el-input-number size="small" v-model.number="addForm.BaleNo" controls-position="right" :min="0" :max="999999" />
                  </el-form-item>
              </el-col>
            </el-row>
<!--            <div class="inTitle">刷唛配置</div>-->
<!--            <el-row :gutter="20">-->
<!--              <el-col :span="12">-->
<!--                <el-form-item label="销售模式：" prop="SalesModel" v-if="paramEditable('system:cs:paramSet:CombBranderCustomization')">-->
<!--                  <el-select size="small" v-model="addForm.SalesModel">-->
<!--                    <el-option v-for="item in SalesModels" :key="`${item.value}`" :label="item.label" :value="item.value"></el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--              <el-col :span="12">-->
<!--                <el-form-item label="产品类型：" prop="ProductType" v-if="paramEditable('system:cs:paramSet:CombBranderCustomization')">-->
<!--                  <el-select size="small" v-model="addForm.ProductType">-->
<!--                    <el-option v-for="item in ProductTypes" :key="`${item.value}`" :label="item.label" :value="item.value"></el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--            <el-row :gutter="20">-->
<!--              <el-col :span="12">-->
<!--                <el-form-item label="控制器类型：" prop="ControllerType" v-if="paramEditable('system:cs:paramSet:CombBranderCustomization')">-->
<!--                  <el-select size="small" v-model="addForm.ControllerType">-->
<!--                    <el-option v-for="item in ControllerTypes" :key="`${item.value}`" :label="item.label" :value="item.value"></el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--              <el-col :span="12">-->
<!--                <el-form-item label="是否刷唛：" prop="IsBrand" v-if="paramEditable('system:cs:paramSet:CombBranderCustomization')">-->
<!--                  <el-select size="small" v-model="addForm.IsBrand">-->
<!--                    <el-option v-for="item in IsBrands" :key="`IsBrand${item.value}`" :label="item.label" :value="item.value"></el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--            </el-row>-->
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="垛号：" prop="CribNo" v-if="paramEditable('system:cs:paramSet:CombCribNo')">
                      <el-select size="small" v-model="addForm.CribNo">
                          <el-option v-for="item in CribNos" :key="item.value" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="籽棉等级：" prop="SeedCottonLevel" v-if="paramEditable('system:cs:paramSet:CombSeedCottonLevel')">
                      <el-input-number size="small" v-model.number="addForm.SeedCottonLevel" controls-position="right" :min="1" :max="9" />
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="每批包数：" prop="BatchBaleCount" v-if="paramEditable('system:cs:paramSet:TbxBatchBaleCount')">
                      <el-input-number size="small" v-model.number="addForm.BatchBaleCount" controls-position="right" :min="1" :max="999999" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="皮重：" prop="Tare" v-if="paramEditable('system:cs:paramSet:TbxTare')">
                      <el-input size="small" v-model.trim="addForm.Tare">
                          <template slot="append">Kg</template>
                      </el-input>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="满包数批号+1：" prop="BatchBaleCountPlusOne" v-if="paramEditable('system:cs:paramSet:CbxAutoBatchAdd')">
                      <el-select size="small" v-model="addForm.BatchBaleCountPlusOne">
                          <el-option v-for="item in BatchBaleCountPlusOnes" :key="`BatchBaleCountPlusOne${item.value}`"
                                     :label="item.label" :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="同时打印追溯卡号数：" prop="SamePrintCottonMoldCount" v-if="paramEditable('system:cs:paramSet:TbxSamePrintCottonMoldCount')">
                      <el-select size="small" v-model="addForm.SamePrintCottonMoldCount">
                          <el-option v-for="item in SamePrintCottonMoldCounts" :key="item.value" :label="item.label"
                                     :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="离线后可工作时间：" prop="OffLineCanWorkHour" v-if="paramEditable('system:cs:paramSet:NtbxOffLineCanWorkHour')">
                      <el-input-number size="small" v-model.number="addForm.OffLineCanWorkHour" controls-position="right" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="离线锁定时间：" prop="OffLineLockDay" v-if="paramEditable('system:cs:paramSet:NtbxOffLineLockDay')">
                      <el-input-number size="small" v-model.number="addForm.OffLineLockDay" controls-position="right" />
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="卷标号剩余数量警告下限：" prop="ExistingVolumeLabelNoWarningFloor" v-if="paramEditable('system:cs:paramSet:NtbxExistingVolumeLabelNoWarningFloor')">
                      <el-input-number size="small" v-model.number="addForm.ExistingVolumeLabelNoWarningFloor" controls-position="right" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">

              </el-col>
            </el-row>
            <div class="inTitle">其它参数</div>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="最大包重：" prop="MaxBaleWeight" v-if="paramEditable('system:cs:paramSet:NtbxMaxBaleWeight')">
                      <el-input size="small" v-model.trim="addForm.MaxBaleWeight">
                          <template slot="append">Kg</template>
                      </el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="最小包重：" prop="MinBaleWeight" v-if="paramEditable('system:cs:paramSet:NtbxMinBaleWeight')">
                      <el-input size="small" v-model.trim="addForm.MinBaleWeight">
                          <template slot="append">Kg</template>
                      </el-input>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="最大回潮：" prop="MaxReturnHumidity" v-if="paramEditable('system:cs:paramSet:NtbxMaxReturnHumidity')">
                      <el-input size="small" v-model.trim="addForm.MaxReturnHumidity">
                          <template slot="append">%</template>
                      </el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="最小回潮：" prop="MinReturnHumidity" v-if="paramEditable('system:cs:paramSet:NtbxMinReturnHumidity')">
                      <el-input size="small" v-model.trim="addForm.MinReturnHumidity">
                          <template slot="append">%</template>
                      </el-input>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="打印色深：" prop="PrintColorDepth" v-if="paramEditable('system:cs:paramSet:CombPrintColorDepth')">
                      <el-input-number size="small" v-model.number="addForm.PrintColorDepth" controls-position="right" :min="20" :max="30" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="打印速度：" prop="PrintSpeed" v-if="paramEditable('system:cs:paramSet:CombPrintSpeed')">
                      <el-input-number size="small" v-model.number="addForm.PrintSpeed" controls-position="right" :min="2" :max="10" />
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="采集最小间隔：" prop="CollectDurationVal" v-if="paramEditable('system.vip.collectDuration')">
                      <el-input-number size="small" v-model.number="addForm.CollectDurationVal" controls-position="right"
                           :max="addForm.CollectDurationUpper" :min="addForm.CollectDurationLower" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="采集间隔值上限：" prop="CollectDurationUpper" v-if="paramEditable('system.vip.collectDuration')">
                      <el-input-number size="small" v-model.number="addForm.CollectDurationUpper" controls-position="right"
                                       :max="600" :min="addForm.CollectDurationLower" @change="setCollectDurationRange('Upper')" />
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="采集间隔值下限：" prop="CollectDurationLower" v-if="paramEditable('system.vip.collectDuration')">
                      <el-input-number size="small" v-model.number="addForm.CollectDurationLower" controls-position="right"
                                       :max="addForm.CollectDurationUpper" :min="10" @change="setCollectDurationRange('Lower')" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="是否开启自动加热：" prop="HeatupState" v-if="paramEditable('system:cs:paramSet:HeatupState')">
                      <el-select size="small" v-model="addForm.HeatupState">
                          <el-option v-for="item in heatups" :key="`${item.value}`" :label="item.label"
                                     :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="加热阈值上限：" prop="HeatupTempUpper" v-if="paramEditable('system:cs:paramSet:HeatupTempUpper')">
                      <el-input-number size="small" v-model.number="addForm.HeatupTempUpper" controls-position="right"
                                       :max="40" :min="addForm.HeatupTempLower" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="加热阈值下限：" prop="HeatupTempLower" v-if="paramEditable('system:cs:paramSet:HeatupTempLower')">
                      <el-input-number size="small" v-model.number="addForm.HeatupTempLower" controls-position="right"
                                       :max="addForm.HeatupTempUpper" :min="10" />
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="加工年度：" prop="Year">
                      <el-input size="small" v-model="addForm.Year" disabled></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="生产线编号：" prop="sccode">
                      <el-input size="small" v-model="addForm.sccode" disabled></el-input>
                  </el-form-item>
              </el-col>
            </el-row>
            <div class="inTitle">排班信息</div>
            <el-row :gutter="20">
              <el-col :span="24">
                <Table :datas="addForm.ShiftInfos" :heads="innerTableHead" :selection="false" @tableAdd="tableAdd" id="ShiftInformation"
                  :remove="!paramEditable()" v-if="paramEditable('system:cs:paramSet:ShiftInformation')">
                  <template #handle="data">
                    <span v-if="
                      data.head.handle == 'Shift' &&
                      paramEditable()
                    ">
                      {{ data.data.Shift }}
                    </span>
                    <el-select v-if="
                      data.head.handle == 'Shift' &&
                      !paramEditable()
                    " size="small" v-model="data.data.Shift">
                      <el-option v-for="item in Shifts" :key="`Shifts${item}`" :label="item" :value="item">
                      </el-option>
                    </el-select>
                    <span
                      v-if="(data.head.handle == 'BeginTime' || data.head.handle == 'EndTime') && paramEditable()">{{
                      data.head.handle == 'BeginTime'?data.data.BeginTime.split(' ')[1]:data.data.EndTime.split(' ')[1]
                      }}</span>
                    <el-date-picker v-if="data.head.handle == 'BeginTime' && !paramEditable()"
                      v-model="data.data.BeginTime" value-format="yyyy-MM-dd HH:mm:ss" format="HH:mm:ss" type="datetime" size="small"
                      placeholder="选择日期时间">
                    </el-date-picker>
                    <el-date-picker v-if="data.head.handle == 'EndTime'  && !paramEditable()"
                      v-model="data.data.EndTime" value-format="yyyy-MM-dd HH:mm:ss" format="HH:mm:ss" type="datetime" size="small"
                      placeholder="选择日期时间">
                    </el-date-picker>
                    <el-input v-if="data.head.handle == 'ShiftLeader'" size="small" v-model="data.data.ShiftLeader" />
                  </template>
                </Table>
              </el-col>
            </el-row>
          </el-form>
        </template>
        <template #footer v-if="!paramEditable()">
          <Btn type="blue" @click="commitData">提交</Btn>
          <Btn @click="closeDrawer">取消</Btn>
        </template>
      </Drawer>
      <el-dialog title="控制指令下发" :visible.sync="commandDialog" width="30%" :before-close="commandClose">
          <el-form label-width="80px">
              <el-row>
                  <el-form-item label="设备类型">
                      <el-select v-model="commandDeviceType" size="small" @change="deviceTypeChange">
                          <el-option v-for="item in deviceType" :key="item.value" :label="item.label" :value="item.value" ></el-option>
                      </el-select>
                  </el-form-item>
              </el-row>
              <el-row>
                  <el-form-item label="命令">
                      <el-select v-model="commandContent" size="small">
                          <el-option v-for="item in commandList" :key="item.value" :label="item.label" :value="item.value" ></el-option>
                      </el-select>
                  </el-form-item>
              </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
              <el-button size="small" @click="commandClose">取 消</el-button>
              <el-button size="small" type="primary" @click="commandCommit">确 定</el-button>
          </span>
      </el-dialog>
    </template>
  </Box>
</template>

<script>
import {
    sbstate,
    deviceType,
    deviceCommand,
    CribNos,
    ForeignFibers,
    ProcessingTypeAuths,
    BatchBaleCountPlusOnes,
    Shifts,
    jglx,
    BrandModels,
    ScreenModels,
    ScreenScrollWays,
    SamePrintCottonMoldCounts,
    TraceModes,
    LectronicWeigherModels,
    com1_9, IsBrands, ControllerTypes, ProductTypes, SalesModels, baudRate, heatups
} from "@/utils/status";
import Region from "@/components/region";
import drawerMixins from "@/components/drawer/drawer";
import permMixin from "@/mixins/perm";
import {
    sbCsList,
    querySbCs,
    parameterSynchronization,
    printerReset,
    euipmentQueryDzc, commandIssued,
} from "@/api/ParamsSetAndSync";
import moment from "moment";
import lodash from "lodash";
import rules, {BranderIP, bt, st} from "@/utils/formRules";
export default {
  mixins: [drawerMixins, permMixin],
  components: { Region },
  data() {
    return {
      sbstate,
      deviceType,
      deviceCommand,
      CribNos,
      com1_9,
      baudRate,
      heatups,
      ForeignFibers,
      ScreenModels,
      ProcessingTypeAuths,
      BatchBaleCountPlusOnes,
      TraceModes,
      BrandModels,
      SalesModels,
      ProductTypes,
      ControllerTypes,
      IsBrands,
      ScreenScrollWays,
      LectronicWeigherModels,
      Shifts,
      SamePrintCottonMoldCounts,
      jglx,
      disabledTitles: ["设置详情"],
      drawerTitle: "详情",
      commandDialog: false,
      commandSbId: '',
      commandDeviceType: '',
      commandContent: '',
      commandList: [],
      queryParams: {
        companyname: "",
        qy: "",
        companycode: "",
      },
      rulse: [],
      ywryData: [],
      tableData: [],
      Year: "",
      tableHead: [
        {
          prop: "xh",
          label: "序号",
          handle: "index",
          width: 50,
          textAlign: "center",
        },
        {
          label: "省",
          prop: "province",
        },
        {
          label: "市",
          minWidth: 100,
          prop: "city",
        },
        {
          label: "区",
          prop: "area",
        },
        {
          label: "企业名称",
          minWidth: 200,
          prop: "companyname",
        },
        {
          label: "设备编号",
          prop: "eqCode",
        },
        {
          label: "生产线",
          prop: "sccode",
          textAlign: "center",
        },
        {
          prop: "cz",
          label: "操作",
          handle: "btns",
          width: 420,
          fixed: "right",
        },
      ],
      // pickerOptionsBegin: {
      //   disabledDate: (time) => {
      //     return time.getTime() < moment().subtract(1, "days");
      //   },
      // },
      innerTableHead: [
        {
          prop: "Shift",
          label: "班次",
          handle: "Shift",
        },
        {
          prop: "BeginTime",
          label: "开始时间",
          handle: "BeginTime",
        },
        {
          prop: "EndTime",
          label: "结束时间",
          handle: "EndTime",
        },
        {
          prop: "ShiftLeader",
          label: "带班人",
          handle: "ShiftLeader",
        },
      ],
      tableSelected: [],
      rules: {
        Tare: rules.Tare,
        LectronicWeigherIP: [...rules.LectronicWeigherIP, bt],
        LectronicWeigherIPPort: [...rules.LectronicWeigherIPPort, bt],
        MoistureMeterIP: [...rules.LectronicWeigherIP, bt],
        MoistureMeterIPPort: [...rules.LectronicWeigherIPPort, bt],
        ScreenIP: [...rules.ScreenIP, bt],
        ScreenPort: [...rules.ScreenPort, bt],
        PhotoelectricDeviceIP: [...rules.PhotoelectricDeviceIP, bt],
        PhotoelectricDeviceIPPort: [...rules.PhotoelectricDeviceIPPort, bt],
        BranderIP: [...rules.BranderIP, bt],
        BranderPort: [...rules.BranderPort, bt],
        CottonKind: [...rules.CottonKind, bt],
        BaleNo: [...rules.BaleNo, bt],
        OffLineCanWorkHour: [bt],
        PrintColorDepth: [bt],
        PrintSpeed: [bt],
        MaxBaleWeight: rules.xiaoShu,
        MinBaleWeight: rules.xiaoShu,
        MaxReturnHumidity: [bt],
        MinReturnHumidity: [bt],
        ExistingVolumeLabelNoWarningFloor: [bt],
        SalesModel: [st],
        ProductType: [st],
        ControllerType: [st],
        IsBrand: [st],
        Tare: rules.xiaoShu,
        SeedCottonLevel: [bt],
        BatchBaleCount: [bt],
        OffLineCanWorkHour: [bt],
        OffLineLockDay: [bt],
      },
      addForm: {
        LectronicWeigherIP: "192.168.1.201",
        LectronicWeigherIPPort: 8000,
        MoistureMeterIP: "192.168.1.202",
        MoistureMeterIPPort: 8001,
        ScreenIP: "192.168.1.205",
        ScreenPort: 8003,
        PhotoelectricDeviceIP: "192.168.1.206",
        PhotoelectricDeviceIPPort: 8004,
        PrintYOffset: 0,
        BranderIP: "192.168.1.207",
        BranderPort: 8899,
        BranderCOM: "COM2",
        PowerControlCOM: "COM4",
        GPSModuleCOM: "COM1",
        EmbosserCOM: "COM3",
        GPSBaudRate: 9600,
        EmbosserBaudRate: 9600,
        PowerControlBaudRate: 9600,
        PrintColorDepth: 20,
        PrintSpeed: 2,
        ScreenModel: "中航 ZH-XM",
        ScreenScrollWay: 0,
        ScreenContentType: "生产参数",
        ScreenContentBaleNo: false,
        ScreenContentSeedCottonLevel: false,
        ScreenContentNet: false,
        ScreenContentTare: false,
        ScreenContentReturnHumidityCate: false,
        ScreenContentProcessingType: false,
        ScreenContentProcessingBatchNumber: false,
        MaxBaleWeight: 237,
        MinBaleWeight: 217,
        MaxReturnHumidity: "",
        MinReturnHumidity: "",
        ExistingVolumeLabelNoWarningFloor: 250,
        Year: "",
        BatchNo: 1,
        // ddd
        sccode: "",
        SalesModel: "",
        ProductType: "",
        ControllerType: "",
        IsBrand: "",
        CottonKind: "000",
        Tare: 0,
        BaleNo: "00001",
        CribNo: 1,
        ForeignFiber: 1,
        SamePrintCottonMoldCount: 4,
        SeedCottonLevel: 3,
        ProcessingTypeAuth: 0,
        ProcessingType: 1,
        BatchBaleCount: 186,
        BatchBaleCountPlusOne: true,
        PrintXOffset: 0,
        PrintCottonMoldNoSwitch: true,
        TraceMode: 0,
        BrandModel: "不刷唛",
        OffLineCanWorkHour: 240,
        OffLineLockDay: 2,
        CollectDurationVal: 120,
        CollectDurationUpper: 600,
        CollectDurationLower: 10,
        HeatupState: 0,
        HeatupTempLower: 20,
        HeatupTempUpper: 30,
        StartStopThreshold: 0,
        ScreenSwitch: true,
        ScreenContentSeedCottonLevel: true,
        LectronicWeigherModel: 0,
        ShiftInfos: [],
      },
      initAddForm: {
        LectronicWeigherIP: null,
        LectronicWeigherIPPort: null,
        MoistureMeterIP: null,
        MoistureMeterIPPort: null,
        ScreenIP: null,
        ScreenPort: null,
        PhotoelectricDeviceIP: null,
        PhotoelectricDeviceIPPort: null,
        PrintYOffset: null,
        BranderIP: null,
        BranderPort: null,
        BranderCOM: null,
        PowerControlCOM: null,
        GPSModuleCOM: null,
        EmbosserCOM: null,
        GPSBaudRate: null,
        EmbosserBaudRate: null,
        PowerControlBaudRate: null,
        PrintColorDepth: null,
        PrintSpeed: null,
        ScreenModel: null,
        ScreenScrollWay: null,
        ScreenContentType: null,
        ScreenContentBaleNo: null,
        ScreenContentSeedCottonLevel: null,
        ScreenContentNet: null,
        ScreenContentTare: null,
        ScreenContentReturnHumidityCate: null,
        ScreenContentProcessingType: null,
        ScreenContentProcessingBatchNumber: null,
        MaxBaleWeight: null,
        MinBaleWeight: null,
        MaxReturnHumidity: null,
        MinReturnHumidity: null,
        ExistingVolumeLabelNoWarningFloor: null,
        Year: null,
        BatchNo: null,
        sccode: null,
        SalesModel: null,
        ProductType: null,
        ControllerType: null,
        IsBrand: null,
        CottonKind: null,
        Tare: null,
        BaleNo: null,
        CribNo: null,
        ForeignFiber: null,
        SamePrintCottonMoldCount: null,
        SeedCottonLevel: null,
        ProcessingTypeAuth: null,
        ProcessingType: null,
        BatchBaleCount: null,
        BatchBaleCountPlusOne: null,
        PrintXOffset: null,
        PrintCottonMoldNoSwitch: null,
        TraceMode: null,
        BrandModel: null,
        OffLineCanWorkHour: null,
        OffLineLockDay: null,
        CollectDurationVal: null,
        CollectDurationUpper: null,
        CollectDurationLower: null,
        HeatupState: null,
        HeatupTempLower: null,
        HeatupTempUpper: null,
        StartStopThreshold: null,
        ScreenSwitch: null,
        ScreenContentSeedCottonLevel: null,
        LectronicWeigherModel: null,
        ShiftInfos: [],
      },
      euipData: [],
      loading: false,
      pageData: {
        total: 0,
        page: 1,
        pageSize: 10,
      },
    };
  },
  methods: {
    change(val) {
      this.queryParams.qy = val;
    },
    tableAdd() {
      const addItem = {
        Shift: "",
        BeginTime: moment().startOf("hour").format("YYYY-MM-DD HH:mm:ss"),
        EndTime: moment().startOf("hour").format("YYYY-MM-DD HH:mm:ss"),
        ShiftLeader: "",
      };
      this.addForm.ShiftInfos.push(addItem);
    },
    initDMJ(data) {
      this.$confirm("确认重置打码机", "打码机重置", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        printerReset(data.sbid).then((res) => {
          this.$message.success(res.msg);
        });
      });
    },
    commandIssued(data) {
        this.commandDialog = true
        this.commandSbId = data.sbid
    },
    deviceTypeChange() {
        this.commandContent = ''
        this.commandList = this.deviceCommand[this.commandDeviceType].command
    },
    commandClose() {
        this.commandDialog = false
        this.commandDeviceType = ''
        this.commandContent = ''
        this.commandList = []
    },
    commandCommit() {
        if (!this.commandDeviceType || !this.commandContent) {
            this.$message.info("请选择设备类型和命令")
            return
        }
        const params = {
            'sbid': this.commandSbId,
            'deviceType': this.commandDeviceType,
            'command': this.commandContent
        }
        commandIssued(params).then(res => {
            this.$message.info(res.msg)
            this.commandClose()
        }).catch(e => {
            this.commandClose()
        })
    },
    setCollectDurationRange(type) {
        if ('Upper' == type) {
            // 上限 < 下限
            if (this.addForm.CollectDurationUpper < this.addForm.CollectDurationLower) {
                this.$set(this.addForm, 'CollectDurationUpper', this.addForm.CollectDurationLower)
            }
            // 间隔 > 上限
            if (this.addForm.CollectDurationVal > this.addForm.CollectDurationUpper) {
                this.$set(this.addForm, 'CollectDurationVal', this.addForm.CollectDurationUpper)
            }
        } else {
            // 下限 > 上限
            if (this.addForm.CollectDurationLower > this.addForm.CollectDurationUpper) {
                this.$set(this.addForm, 'CollectDurationLower', this.addForm.CollectDurationUpper)
            }
            // 间隔 < 下限
            if (this.addForm.CollectDurationVal < this.addForm.CollectDurationLower) {
                this.$set(this.addForm, 'CollectDurationVal', this.addForm.CollectDurationLower)
            }
        }
    },
    getDuipData() {
      euipmentQueryDzc().then((res) => {
        this.euipData = res.data;
      });
    },
    ProcessingTypeAuthChange(val) {
      this.addForm.ProcessingType = ProcessingTypeAuths.find(
        (a) => a.value == val
      ).children[0];
    },
    async handleItem(data, drawerTitle) {
      this.drawerTitle = drawerTitle;
      this.addForm = {
        ...this.initAddForm,
      };
      await querySbCs(data.sbid).then((res) => {
        try {
          if (res.data.cspz) this.addForm = JSON.parse(res.data.cspz);
          if (!Object.keys(this.addForm).includes("ShiftInfos")) {
            this.$set(this.addForm, "ShiftInfos", []);
          }
        } catch (err) {
          this.addForm = {
            ...this.initAddForm,
          };
        }
        if (this.addForm.Year == 0) this.addForm.Year = "";
        this.addForm.id = res.data.id;
        this.addForm.sbid = res.data.sbid;
        // this.addForm.Year = this.Year;
        this.addForm.sccode = data.sccode;
        // Set default value
        if (!this.addForm.BranderIP) this.$set(this.addForm, 'BranderIP', '192.168.1.207')
        if (!this.addForm.BranderPort) this.$set(this.addForm, 'BranderPort', 8899)
        if (!this.addForm.GPSBaudRate) this.$set(this.addForm, 'GPSBaudRate', 9600)
        if (!this.addForm.EmbosserBaudRate) this.$set(this.addForm, 'EmbosserBaudRate', 9600)
        if (!this.addForm.PowerControlBaudRate) this.$set(this.addForm, 'PowerControlBaudRate', 9600)
        if (!this.addForm.CollectDurationVal) this.$set(this.addForm, 'CollectDurationVal', 120)
        if (!this.addForm.CollectDurationUpper) this.$set(this.addForm, 'CollectDurationUpper', 600)
        if (!this.addForm.CollectDurationLower) this.$set(this.addForm, 'CollectDurationLower', 10)
        if (!this.addForm.HeatupTempUpper) this.$set(this.addForm, 'HeatupTempUpper', 30)
        if (!this.addForm.HeatupTempLower) this.$set(this.addForm, 'HeatupTempLower', 20)
      });
      this.changeOpen();
    },
    commitData() {
      this.$refs.addForm.validate(async (valid) => {
        if (!valid) {
          this.$message.error("请检查表单");
          return false;
        }
        // 有权限的参数表单
        const formKey = [...new Set(Object.keys(this.addForm))] // addForm所有属性的集合
        let formLabel = new Set() // 页面所有label的for属性集合
        const labelArr = document.getElementsByTagName('label')
        for (const label of labelArr) {
          const forNode = label.getAttributeNode('for')?.value
          formLabel.add(undefined == forNode ? label.getAttributeNode('prop')?.value : forNode)
        }
        // 过滤addForm里页面有的属性
        let intersection = formKey.filter(f => formLabel.has(f))
        let cspzForm = {} // 参数form
        for (const p of intersection) {
          cspzForm[p] = this.addForm[p]
        }
        const shiftInformation = document.getElementById('ShiftInformation')
        if (shiftInformation) {
            cspzForm['ShiftInfos'] = this.addForm.ShiftInfos
        }
        // 判断是否有重复的com 1_9
        let arr = [
          // cspzForm.BranderCOM,
          cspzForm.PowerControlCOM,
          cspzForm.GPSModuleCOM,
          cspzForm.EmbosserCOM,
        ]
        arr = arr.filter(r => { return r != undefined })
        const resArr = [...new Set(arr)]
        if (resArr && resArr.length != arr.length) {
          function duplicates(arr) {
            var Arr = [];
            arr.forEach((elem) => {
              if (arr.indexOf(elem) !== arr.lastIndexOf(elem) && Arr.indexOf(elem) === -1) {
                Arr.push(elem);
              }
            });
            return Arr;
          }
          const _arr = duplicates(arr)
          let str = ''
          _arr.forEach((text, index) => {
            str = str + text
            if (index < _arr.length - 1) str += ','
          })
          this.$message.error(`${str} 重复，请检查表单！`);
          return false
        }
        const params = {
          id: this.addForm.id,
          sbid: this.addForm.sbid,
        };
        const cspz = Object.assign({}, cspzForm);
        if (cspz.Year == "") cspz.Year = 0;
        params.cspz = JSON.stringify(cspz);
        await parameterSynchronization(params).then(() => {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.changeOpen();
          this.getList();
        });
        this.addForm = {
          ...this.initAddForm,
        };
      });
    },
    initQuery() {
      this.pageData.page = 1;
      this.$refs.query_form.resetFields();
      this.queryParams.qy = "";
    },
    query() {
      this.pageData.page = 1;
      this.getList();
    },
    getList() {
      this.loading = true
      const params = {
        ...this.queryParams,
        currentPage: this.pageData.page,
        pageSize: this.pageData.pageSize
      };
      sbCsList(params)
        .then((res) => {
          this.pageData.total = res.data.count;
          this.tableData = res.data?.list || [];
          this.Year = res.data?.year || "";
          this.loading = false
        })
        .catch((err) => {
          this.pageData.total = 0;
          this.tableData = [];
          this.Year = "";
          this.loading = false
        });
    },
    toPath(path, data) {
      if (!data.sbid) return;
      this.$router.push({
        path,
        query: {
          sbId: data.sbid,
        },
      });
    },
    paramEditable(perms) {
        const baseAble = this.disabledTitles.includes(this.drawerTitle)
        if (perms) {
            return baseAble || this.hasPermi(perms)
        }
        return baseAble
    }
  },
  computed: {
    // jglxTooltips() {
    //   const _tmp = [];
    //   this.ProcessingTypeAuths.forEach((item) => {
    //     const _item = {
    //       label: item.label,
    //       value: item.value,
    //     };
    //     for (let i = 0; i < item.children.length; i++) {
    //       _item.children.push(
    //         (
    //           this.jglx.find((b) => b.value == item.children[i]) || {
    //             label: "",
    //           }
    //         ).label
    //       );
    //     }
    //     _tmp.push(_item);
    //   });
    //   return _tmp;
    // },
    // false 可编辑 ture 只读
  },
  created() {
    this.getDuipData();
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-row {
    position: relative;

    .fwz {
      position: absolute;
      left: 445px;
      display: flex;
      align-items: center;
      height: 30px;
      top: 2px;
    }
  }

  // .disabled {
  //   .el-form-item__content .el-input-group {
  //     vertical-align: middle;
  //   }

  // }
}
</style>
